import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { FaBell, FaUserCircle, FaChevronDown, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const DashboardHeader = ({ 
    icon: Icon, 
    title, 
    subtitle, 
    iconBgColor = 'bg-blue-50', 
    iconColor = 'text-blue-600',
    onMenuToggle,
    showSearch = false,
    searchValue = '',
    onSearchChange = () => {}
}) => {
    const { user } = useAuth();
    const [showNotifications, setShowNotifications] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(false);

    return (
        <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
            <div className="px-6 py-4">
                <div className="flex items-center justify-between">
                    {/* Left Section - Title & Icon */}
                    <div className="flex items-center gap-4">
                        {onMenuToggle && (
                            <button
                                data-menu-toggle
                                onClick={onMenuToggle}
                                className="lg:hidden text-gray-600 hover:text-gray-900 p-2 rounded-lg hover:bg-gray-100"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                        )}
                        <div className="flex items-center gap-3">
                            {Icon && (
                                <div className={`p-2 ${iconBgColor} rounded-lg hidden sm:block`}>
                                    <Icon className={`text-2xl ${iconColor}`} />
                                </div>
                            )}
                            <div>
                                <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
                                {subtitle && <p className="text-sm text-gray-600 hidden sm:block">{subtitle}</p>}
                            </div>
                        </div>
                    </div>

                    {/* Right Section - Search, Notifications, User */}
                    <div className="flex items-center gap-4">
                        {/* Search Bar */}
                        {showSearch && (
                            <div className="hidden md:flex items-center gap-2 bg-gray-100 rounded-lg px-4 py-2 min-w-[300px]">
                                <FaSearch className="text-gray-400" />
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchValue}
                                    onChange={(e) => onSearchChange(e.target.value)}
                                    className="bg-transparent border-none outline-none flex-1 text-sm"
                                />
                            </div>
                        )}

                        {/* Notifications */}
                        <div className="relative">
                            <button
                                onClick={() => setShowNotifications(!showNotifications)}
                                className="relative p-2 text-gray-600 hover:text-gray-900 rounded-lg hover:bg-gray-100 transition-colors"
                            >
                                <FaBell className="text-xl" />
                                <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
                            </button>
                            {showNotifications && (
                                <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                                    <div className="px-4 py-2 border-b border-gray-200">
                                        <h3 className="font-semibold text-gray-900">Notifications</h3>
                                    </div>
                                    <div className="max-h-96 overflow-y-auto">
                                        <div className="px-4 py-8 text-center text-gray-500 text-sm">
                                            No new notifications
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* User Menu */}
                        <div className="relative">
                            <button
                                onClick={() => setShowUserMenu(!showUserMenu)}
                                className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 transition-colors"
                            >
                                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                                    {user?.email ? (
                                        <span className="text-white text-sm font-semibold">
                                            {user.email.charAt(0).toUpperCase()}
                                        </span>
                                    ) : (
                                        <FaUserCircle className="text-white text-xl" />
                                    )}
                                </div>
                                <FaChevronDown className="text-gray-500 text-xs hidden sm:block" />
                            </button>
                            {showUserMenu && (
                                <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                                    <div className="px-4 py-3 border-b border-gray-200">
                                        <p className="text-sm font-semibold text-gray-900">
                                            {user?.first_name && user?.last_name
                                                ? `${user.first_name} ${user.last_name}`
                                                : user?.email || 'User'}
                                        </p>
                                        <p className="text-xs text-gray-500 mt-1">{user?.email}</p>
                                    </div>
                                    <Link
                                        to="/profile/edit"
                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                                        onClick={() => setShowUserMenu(false)}
                                    >
                                        Profile Settings
                                    </Link>
                                    <Link
                                        to="/settings"
                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                                        onClick={() => setShowUserMenu(false)}
                                    >
                                        Preferences
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default DashboardHeader;

